<template>
  <div class="passed_run">
    <head-top head-title="跑楼审核" go-back="true"></head-top>
    <div class="pass_main">
        <div class="list_box" v-for="(item,index) in data" :key="index">
          <h3>{{item.name}}</h3>
          <div class="box_single" v-for="(des, dindex) in item.data" :key="dindex">
            <div class="basics">
              <div class="bas_li"><span>姓名：</span>{{des.real_name}}</div>
              <div class="bas_li"><span>手机号：</span>{{des.phone}}</div>
              <div class="bas_li"><span>结束时间：</span>{{ des.end_time? des.end_time:'暂无'}}</div>
            </div>
          </div>
      </div>
      <div class="default1" v-show="noResult">
        <p>抱歉！暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../../../components/header/Header'
  import {buildAudit} from '../../../api/my'
  import {Indicator} from 'mint-ui'
  export default {
    name: 'PassedRun',
    data () {
      return {
        data: [],
        type: 1,
        noResult: false
      }
    },
    created() {
      this._buildAudit()
    },
    methods: {
      // 列表数据
      _buildAudit() {
        Indicator.open({
          text: '..加载中..',
          spinnerType: 'fading-circle'
        })
        buildAudit(this.type).then(res => {
          // console.log(res)
          if (res.code === 200) {
            Indicator.close()
            this.data = res.data
            if (this.data.length === 0) {
              this.noResult = true
            } else {
              this.noResult = false
            }
            // console.log(this.data)
          }
        })
      }
    },
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
  .passed_run{
    padding-top: 50px;
    .pass_main{
      .list_box{
          h3{
            font-size: 17px;
            color: #0C7AD9;
            padding: 10px;
            background: #f2f2f2;
          }
          .box_single{
            padding: 10px;
            /*border-bottom: 10px solid #f2f2f2;*/
            .basics{
              border-radius: 5px;
              border: 1px solid #f2f2f2;
              box-shadow: 3px 2px 5px #f2f2f2;
              padding: 10px 10px;
              margin-top: 10px;
              .bas_li{
                font-size: 15px;
                color: #666666;
                margin-top: 10px;
                span{
                  color: #333333;
                }
              }
            }
          }
      }
      .default1 {
        width: 100%;
        flex: 1;
        display: inline-flex;
        padding-top: 100px;
        justify-content: center;
        align-items: center;
        background: url("../../../assets/default.png") no-repeat;
        background-size: 100px 100px;
        background-position: center;
        padding-bottom: 140px;
        p {
          font-size: 15px;
          color: #0b7ad9;
          margin-top: 180px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/runBuild/PassedRun.vue